var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        [
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !this.loading,
                  expression: "!this.loading"
                }
              ],
              attrs: { "align-h": "center" }
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "mb-1", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-header",
                        {
                          staticClass: "p-1",
                          attrs: { "header-tag": "header", role: "tab" }
                        },
                        [
                          _c(
                            "b-btn",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle.accordion1",
                                  modifiers: { accordion1: true }
                                }
                              ],
                              attrs: {
                                block: "",
                                href: "#",
                                variant: "primary"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Search Criteria\n            "
                              ),
                              !_vm.showCriteria
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "caret-down", size: "lg" }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showCriteria
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "caret-up", size: "lg" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            id: "accordion1",
                            visible: "",
                            accordion: "accordion1",
                            role: "tabpanel"
                          },
                          model: {
                            value: _vm.showCriteria,
                            callback: function($$v) {
                              _vm.showCriteria = $$v
                            },
                            expression: "showCriteria"
                          }
                        },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c(
                                "b-container",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Element")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.elementList,
                                                      placeholder:
                                                        "Select Element"
                                                    },
                                                    model: {
                                                      value: _vm.element,
                                                      callback: function($$v) {
                                                        _vm.element = $$v
                                                      },
                                                      expression: "element"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Programme(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options:
                                                        _vm.programmeList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      "track-by": "id",
                                                      label: "name",
                                                      placeholder:
                                                        "Do not report on Programme"
                                                    },
                                                    model: {
                                                      value: _vm.programmes,
                                                      callback: function($$v) {
                                                        _vm.programmes = $$v
                                                      },
                                                      expression: "programmes"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Industry(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.industryList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder:
                                                        "Do not report on Industry",
                                                      "select-label": "",
                                                      "deselect-label": ""
                                                    },
                                                    model: {
                                                      value: _vm.industries,
                                                      callback: function($$v) {
                                                        _vm.industries = $$v
                                                      },
                                                      expression: "industries"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Year(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.yearList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder:
                                                        "Do not report on Year"
                                                    },
                                                    model: {
                                                      value: _vm.years,
                                                      callback: function($$v) {
                                                        _vm.years = $$v
                                                      },
                                                      expression: "years"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Customer(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.customerList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      "track-by": "id",
                                                      label: "name",
                                                      placeholder:
                                                        "Do not report on Customer"
                                                    },
                                                    model: {
                                                      value: _vm.customers,
                                                      callback: function($$v) {
                                                        _vm.customers = $$v
                                                      },
                                                      expression: "customers"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Country(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.countryList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder:
                                                        "Do not report on Country"
                                                    },
                                                    model: {
                                                      value: _vm.countries,
                                                      callback: function($$v) {
                                                        _vm.countries = $$v
                                                      },
                                                      expression: "countries"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "text-left text-nowrap",
                                                  attrs: { cols: "3" }
                                                },
                                                [_vm._v("Region(s)")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: _vm.regionList,
                                                      multiple: true,
                                                      "close-on-select": false,
                                                      placeholder:
                                                        "Do not report on Region",
                                                      "group-values": "regions",
                                                      "group-label": "country",
                                                      "group-select": true
                                                    },
                                                    model: {
                                                      value: _vm.regions,
                                                      callback: function($$v) {
                                                        _vm.regions = $$v
                                                      },
                                                      expression: "regions"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            { staticClass: "pb-2" },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-btn",
                                                    {
                                                      attrs: {
                                                        variant: "primary",
                                                        disabled:
                                                          !_vm.element ||
                                                          _vm.element.length ==
                                                            0
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.calculateData()
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Show")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass: "pb-5 pt-5 text-center",
              attrs: { "align-h": "center" }
            },
            [
              _c(
                "b-col",
                [
                  _c("font-awesome-icon", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loadingData,
                        expression: "loadingData"
                      }
                    ],
                    attrs: { icon: "spinner", size: "lg", spin: "" }
                  }),
                  _vm._v(" "),
                  _vm.chartData
                    ? _c("element-industry-bar", {
                        attrs: {
                          "chart-data": _vm.chartData,
                          "element-name": _vm.element,
                          width: 1000,
                          height: 600
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f3c2ea5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f3c2ea5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndustryElements.vue
// module id = null
// module chunks = 